import axios from "axios";
import * as  actionTypes from "./actionTypes";
import { failFetchFeaturedDealers } from "./LandingActions";

export const initGetDetailItem = () => {
    return {
        type: actionTypes.INIT_GET_DETAIL_ITEM,
        itemLoading: true
    }
};

export const successGetDetailItem = (data) => {
    return {
        type: actionTypes.SUCCESS_GET_DETAIL_ITEM,
        vehicle: data,
        itemLoading: false
    }
};

export const failGetDetailItem = (error) => {
    return {
        type: actionTypes.SUCCESS_GET_DETAIL_ITEM,
        error: error
    }
};

export const chechItemHasVideo = (hasVideo) => {
    return {
        type: actionTypes.CHECK_ITEM_HAS_VIDEO,
        hasVideo: hasVideo,
        checkingHasVideo: false
    }
};

export const CheckingHasVideo = () => {
    return {
        type: actionTypes.CHECKING_HAS_VIDEO,
        checkingHasVideo: true
    }
};

export const getDetailItem = (type, id, addingComment) => {
    let hasVideo = null;
    return dispatch => {
        if (!addingComment){
            dispatch(initGetDetailItem())
        }
        axios.get(`all/lists/${id}`)
            .then((response) => {
                dispatch(successGetDetailItem(response.data))
                dispatch(CheckingHasVideo())
                return response.data.data
            })
            .then((dta) => {
                if (dta.media.length !== 0) {
                    hasVideo = dta.media.some(img => img.name === 'video')
                    dispatch(chechItemHasVideo(hasVideo))
                }
            }
            )
            .catch(error => {
                dispatch(failFetchFeaturedDealers(error))
            })
    }

};

export const postAddComment = (vehicleType, vehicleId, token, content, parentId) => {
    const data = {
        content: content,
        parent_comment_id: parentId
    }
    const config = {
        headers: {
            Authorization: "Bearer " + token
        }
    }
    return dispatch => {
        axios.post(`${vehicleType}/lists/${vehicleId}/comments`, data, config)
            .then(response => {
                dispatch(getDetailItem(vehicleType, vehicleId, true))
            })
            .catch(error=>{
                console.log(error)
            })
    }
}